export * from './forTesting.tmpl';
export * from './TefComs4cs4p';
export * from './tefComsButton.tmpl';
export * from './tefComsCancelButton.tmpl';
export * from './tefComsLoader.tmpl';
export * from './tefComsSaveButton.tmpl';
